function getPreparedPageName(pageName) {
  return (pageName ?? '')
    .replace(/([\s]+)/gu, '-')
    .replace(/[^a-zA-Z0-9-]/gu, '')
    .replace(/([-]+)/gu, '-')
    .replace(/^[-]|[-]$/gu, '')
    .toLowerCase()
    .substring(0, 100);
}

export default getPreparedPageName;
